<template>
  <div class="p-test-screen">
    <page-title>Test Screen</page-title>

    <section-block>
      <template slot="header">
        <h3>Notifications</h3>
      </template>

      <form-field label="title" v-model="notification.title"></form-field>
      <form-field label="body" v-model="notification.body"></form-field>

      <base-button :primary="true" @click="testNotification">Test notification</base-button>

      <hr>

      <pre>{{notifications}}</pre>
    </section-block>

    <section-block>
      <template slot="header">
        <h3>Dialog</h3>
      </template>

      <base-button danger @click="testDialog">Test Dialog</base-button>
      <base-dialog v-if="dialog.isOpen" @cancel="dialog.isOpen = false" @confirm="dialogConfirm"></base-dialog>

      <base-button danger @click="testStoreDialog">Test Dialog (store)</base-button>
    </section-block>

    <section-block>
      <div class="test-tint test-tint--100"></div>
      <div class="test-tint test-tint--80"></div>
      <div class="test-tint test-tint--60"></div>
      <div class="test-tint test-tint--40"></div>
      <div class="test-tint test-tint--20"></div>
    </section-block>
  </div>
</template>

<script>
export default {
  name: 'test-screen',

  data() {
    return {
      notification: {
        title: null,
        body: null,
        type: 'success',
      },
      dialog: {
        isOpen: false,
      },
    };
  },

  methods: {
    testNotification() {
      const notification = this.notification;
      this.$store.dispatch('notifications/create', notification);
    },

    testDialog() {
      this.dialog.isOpen = true;
    },

    dialogConfirm() {
      this.dialog.isOpen = false;
      alert('confirmed');
    },

    testStoreDialog() {
      this.$store.dispatch('createDialog', {
        confirm: this.dialogConfirm,
      });
    },
  },

  computed: {
    notifications() {
      return this.$store.state.notifications.collection;
    },
  },
};
</script>

<style lang="scss">
.test-tint {
  height: 100px;
  width: 100%;

  &--100 {
    background: $colour-nhs-dark-blue;
  }
  &--80 {
    background: tint($colour-nhs-dark-blue, 80);
  }
  &--60 {
    background: tint($colour-nhs-dark-blue, 60);
  }
  &--40 {
    background: tint($colour-nhs-dark-blue, 40);
  }
  &--20 {
    background: tint($colour-nhs-dark-blue, 20);
  }
}
</style>
